import React from 'react';
import { LoadingStyled } from './styles';

const Loading = () => {
  return <LoadingStyled>Loading...</LoadingStyled>;
};

export default Loading;
